import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { IntegratorDetail } from '@types';

export const useIntegrators = (): IntegratorDetail[] => {
	// keep this hook here to update when translations obtained
	// useTranslation();
	// const integratorsResources = TranslationHelper.getByKey('eCommerce.integrators');
	// const integrators: IntegratorDetail[] = (integratorsResources?.result as Anything) || [];
	// return integrators;

	const t = useTranslation();

	const integratorsData = t('ecommerce.integrators');

	const parsed = JSON.parse(integratorsData);

	return parsed?.ecommerce?.integrators ?? [];
};
